enum ItemStatus {
  PENDING = 'PENDING',
  CONFIRM = 'CONFIRM',
  REJECT = 'REJECT',
  HAS_INVOICE = 'HAS_INVOICE'
}

export default ItemStatus;
